import React, { useEffect } from "react";
import { Mail, MapPin } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Careers() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // or "smooth"
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#050A07] text-white">
      <Header />

      <main className="max-w-5xl mx-auto px-6 md:px-10 pt-32 pb-12 lg:pt-36">
        <section className="reveal">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-extrabold gradient-text-saffron">
              Careers at Indian Eco Fuels
            </h1>
            <p className="mt-3 text-white/60">
              Join us in building India’s sustainable energy future.
            </p>
          </div>

          <div className="grid gap-8">
            <div className="glass-card p-6">
              <h3 className="text-xl font-semibold mb-3">Careers</h3>
              <p className="text-sm text-white/70 mb-4">
                We welcome professionals passionate about clean energy. To apply,
                please email your CV (PDF) and a short cover note to:
              </p>

              <a
                href="mailto:careers@indianecofuels.co"
                className="inline-flex items-center gap-2 text-eco-light font-semibold"
              >
                <Mail className="w-4 h-4" />
                careers@indianecofuels.co
              </a>

              <p className="mt-6 text-sm text-white/60">
                That's all — send your CV and we'll be in touch if there's a match.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center text-sm text-white/60">
            <p>
              Prefer to reach out? Call us at{" "}
              <a
                href="tel:+918930225999"
                className="text-eco-light"
              >
                +91 8930225999
              </a>
            </p>

            <p className="mt-3">Visit our office:</p>

            <p className="mt-2 flex items-center justify-center gap-2">
              <MapPin className="w-4 h-4 text-eco-light" />
              <a
                href="https://www.google.com/maps/search/?api=1&query=SCO+15+HSVP+Complex+Sector+4-5+Karnal+132001"
                target="_blank"
                rel="noreferrer"
                className="text-eco-light font-medium"
              >
                SCO 15, HSVP Complex, Sector 4-5, Karnal 132001
              </a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}